/* eslint-disable no-nested-ternary */
import Icon, {
  DownOutlined,
  LogoutOutlined,
  SlackOutlined,
} from "@ant-design/icons";
import { Button, List, Popover, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSupaClient } from "../../lib/supabase";

import { logout } from "../../utils/general";

const SelectWorkspace = (props) => {
  const supabase = getSupaClient();
  const session = supabase.auth.session();

  const navigate = useNavigate();
  const userTeams = localStorage.getItem("teams");
  const teams = JSON.parse(userTeams) || [];

  const teamId = localStorage.getItem("team-id");

  const [teamOptions, setTeamOptions] = useState(teams);

  const currentPlatform = localStorage.getItem("platform");
  const discordId = localStorage.getItem("discord-id");

  const initTeam = teamOptions.find((t) => {
    if (currentPlatform === "slack") return t.team.slack_id === teamId;
    if (currentPlatform === "discord") return t.discord_id === discordId;
    return null;
  });

  const [selectedTeam, setSelectedTeam] = useState(initTeam);
  const [teamInitials, setTeamInitials] = useState("");
  const [teamTruncatedName, setTeamTruncatedName] = useState("");

  const updateWorkspace = async (workspace) => {
    // using fetch to get all teams end point /guilds/dots
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/users/${session.user.id}/workspace/${workspace}`,
      {
        headers: {
          Authorization: `Bearer ${session.access_token}`,
        },
        method: "PUT",
      }
    );

    const data = await response.json();
    if (data.error) {
      //Segment track error here
      window.analytics.track(
        `Error updating workspace error: ${data.error}, 
          user id: ${session.user.id}, 
          user workspace: ${session.user.app_metadata.workspace} 
          target workspace: ${workspace}`
      );

      throw new Error(data.error);
    }

    await supabase.auth.refreshSession();
    localStorage.removeItem("team-id");
    localStorage.removeItem("guild-id");
    localStorage.removeItem("teams");
    localStorage.removeItem("approved");
    window.location.reload();
  };

  // for selection of Slack teams
  const onTeamSelect = (val) => {
    const selected = teams.find((userTeam) => userTeam.slack_id === val);
    setSelectedTeam(selected);
    localStorage.setItem("platform", "slack");
    localStorage.setItem("team-id", selected.team.slack_id);
    localStorage.setItem("slack-id", selected.slack_id);
    localStorage.setItem("team-name", selected.team.name);
    localStorage.setItem("paid", selected.team.paid_user);
    localStorage.setItem("trial-end", selected.team.trial_end);
    localStorage.setItem("team-created-at", selected.team.created_at);
    // remove discord related
    localStorage.removeItem("guild-id");
    localStorage.removeItem("guild-name");
    localStorage.removeItem("discord-id");
    window.location.reload();
  };

  // for selection of Discord server
  const onServerSelect = (val) => {
    const selected = teams.find((userTeam) => userTeam.discord_id === val);
    setSelectedTeam(selected);
    localStorage.setItem("platform", "discord");
    localStorage.setItem("guild-id", selected.guild.discord_id);
    localStorage.setItem("discord-id", selected.discord_id);
    localStorage.setItem("guild-name", selected.guild.name);
    localStorage.setItem("guild-is-active", selected.guild.is_active);

    // remove slack related
    localStorage.removeItem("team-id");
    localStorage.removeItem("team-name");
    localStorage.removeItem("slack-id");

    //It means the selected server is not in the same workspace as the current workspace so update the user's workspace
    if (session.user.app_metadata.workspace !== selected.guild.workspace) {
      updateWorkspace(selected.guild.workspace);
    } else {
      window.location.reload();
    }
  };

  const onSwitch = () => {};

  const content = (
    <Space
      direction="vertical"
      style={{ alignContent: "center", borderRadius: 10 }}
    >
      <div>
        <List
          dataSource={teamOptions}
          className="px-5"
          style={{
            cursor: "pointer",
            overflow: "auto",
            maxHeight: "500px",
          }}
          renderItem={(item) => {
            if (Object.prototype.hasOwnProperty.call(item, "team")) {
              return (
                <List.Item
                  key={item.slack_id}
                  onClick={() => onTeamSelect(item.slack_id)}
                  className="team-selecter-item"
                  style={{
                    backgroundColor:
                      selectedTeam.team?.name === item.team.name
                        ? "#FFDEC0"
                        : "",
                  }}
                >
                  <Space className="mx-1">
                    <Icon
                      component={() => <SlackOutlined className="pb-1" />}
                    />
                    {item.team.alias ? (
                      <span>{item.team.alias}</span>
                    ) : (
                      <span>{item.team.name}</span>
                    )}
                  </Space>
                </List.Item>
              );
            }
            if (Object.prototype.hasOwnProperty.call(item, "guild")) {
              return (
                <List.Item
                  key={item.discord_id}
                  onClick={() => onServerSelect(item.discord_id)}
                  className="team-selecter-item"
                  style={{
                    backgroundColor:
                      selectedTeam.guild?.name === item.guild.name
                        ? "#FFDEC0"
                        : "",
                  }}
                >
                  <Space className="mx-1">
                    <Icon
                      component={() => (
                        <img
                          src="/discord.svg"
                          alt="discord"
                          width="12"
                          className="pb-1"
                        />
                      )}
                    />
                    <span>{item.guild.name}</span>
                  </Space>
                </List.Item>
              );
            }
            return null;
          }}
        />
      </div>
      <div>
        <Button type="primary" block onClick={() => navigate("/settings")}>
          + New community
        </Button>
      </div>
      <div>
        <Button
          key="21"
          block
          onClick={async () => {
            await logout();
            navigate("/signin");
            window.CommandBar.shutdown();
          }}
          icon={<LogoutOutlined />}
        >
          Logout
        </Button>
      </div>
    </Space>
  );

  /**
   * Takes a team name and returns its initials
   * @param {*} teamAlias the team name
   */
  const getTeamInitials = (teamAlias) => {
    const letterArray = teamAlias.split(" ");

    // If the team name has 2 or more words, return first 2 initials
    if (letterArray.length > 1) {
      const firstInitial = letterArray[0][0].toUpperCase();
      const secondInitial = letterArray[1][0].toUpperCase();
      const initials = firstInitial + secondInitial;
      setTeamInitials(initials);
    } else {
      // If the team name has only one word, return first letter
      const initial = letterArray[0][0].toUpperCase();
      setTeamInitials(initial);
    }
  };

  /**
   * Takes a team name and returns its initials
   * @param {*} teamAlias the team name
   */
  const getTeamTruncatedName = (teamAlias) => {
    // If the team name has 2 or more words, return first 2 initials
    if (teamAlias.length > 20) {
      setTeamTruncatedName(
        !props.disableTeamNameTruncate
          ? `${teamAlias.substring(0, 15)}...`
          : teamAlias
      );
    } else {
      // If the team name has only one word, return first letter
      setTeamTruncatedName(teamAlias);
    }
  };

  useEffect(() => {
    if (currentPlatform === "slack") {
      if (selectedTeam.team.alias) {
        getTeamInitials(selectedTeam.team.alias);
        getTeamTruncatedName(selectedTeam.team.alias);
      } else {
        getTeamInitials(selectedTeam.team.name);
        getTeamTruncatedName(selectedTeam.team.name);
      }
    } else {
      getTeamInitials(selectedTeam.guild.name);
      getTeamTruncatedName(selectedTeam.guild.name);
    }
  }, []);

  return (
    <div style={{ color: "white" }}>
      <Popover
        content={content}
        title="Switch to:"
        trigger="hover"
        placement={props.isCollapsed === true ? "rightTop" : "bottomRight"}
      >
        <div className="flex flex-row justify-center">
          {!props.isCollapsed ? (
            <>
              <div
                className="pt-0.5"
                style={{ maxHeight: 20, maxWidth: "100%" }}
              >
                <p className="text-black overflow-hidden truncate">
                  {teamTruncatedName}
                </p>
              </div>
              <div className="ml-1.5">
                <DownOutlined style={{ color: "#000" }} />
              </div>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  margin: "auto",
                  fontWeight: 400,
                  fontSize: "1.1em",
                  marginTop: "4px",
                }}
              >
                {teamInitials}
              </div>
            </div>
          )}
        </div>
      </Popover>
    </div>
  );
};

export default SelectWorkspace;
